import { createAction, handleActions } from 'redux-actions';

import { List, Map, fromJS } from 'immutable';
import { pender } from 'redux-pender';

import * as common from 'libs/commonFunc';
import * as declareLib from 'libs/declareLib';
import * as normalizer from 'libs/normalizer';

// action types
const INITIAL_STORE = 'declare/INITIAL_STORE';
const CHANGE_DECLARE = 'declare/CHANGE_DECLARE';
const CHANGE_DECLARE_PARAM = 'currentStatus/CHANGE_DECLARE_PARAM';
const GET_DECLARE = 'declare/GET_DECLARE';
const GET_DECLARE_DETAIL = 'declare/GET_DECLARE_DETAIL';
const GET_DECLARE_MAIL = 'declare/GET_DECLARE_MAIL';
const GET_DECLARE_EXAM = 'declare/GET_DECLARE_EXAM';
const PUT_DECLARE = 'declare/PUT_DECLARE';
const DELETE_DECLARE = 'declare/DELETE_DECLARE';
const SET_DECLARE_REFRESH = 'declare/SET_DECLARE_REFRESH';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeDeclare = createAction(CHANGE_DECLARE);
export const changeDeclareParam = createAction(CHANGE_DECLARE_PARAM);
export const getDeclare = createAction(GET_DECLARE, declareLib.getDeclareAPI);
export const getDeclareDetail = createAction(GET_DECLARE_DETAIL, declareLib.getDeclareDetailAPI);
export const getDeclareMail = createAction(GET_DECLARE_MAIL, declareLib.getDeclareMailAPI);
export const getDeclareExam = createAction(GET_DECLARE_EXAM, declareLib.getDeclareExamAPI);
export const putDeclare = createAction(PUT_DECLARE, declareLib.putDeclareAPI);
export const deleteDeclare = createAction(DELETE_DECLARE, declareLib.deleteDeclareAPI);
export const setDeclareRefresh = createAction(SET_DECLARE_REFRESH);

// initial state
const initialState = Map({
  // 새로고침
  needReload: false,
  page: 1,
  totalPages: 0,
  totalDeclare: 0,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'declareNo', order: 'DESC' }],
    offset: 0,
    limit: 30
  }),
  // 필터 리스트
  filter: Map({}),
  declareOrdering: List([]),
  declareDataByTargetNo: Map({}),
  declareDetailOrdering: List([]),
  declareDetail: Map({}),
  declareExamOrdering: List([]),
  declareExamByExamNo: Map({}),
  examNoArray: List(['all']),
  declareRefresh: false
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_DECLARE]: (state, action) => {
      const { name, value } = action.payload;

      return state.set(name, value);
    },
    [CHANGE_DECLARE_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    // 신고 리스트 새로고침
    [SET_DECLARE_REFRESH]: (state, action) => {
      const { name, value } = action.payload;

      return state.set(name, value);
    },

    // 신고 훈련 탭 항목 조회
    ...pender({
      type: GET_DECLARE,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }
        const { list, filter } = action.payload.data;
        const { refresh, offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = list.length > 0 ? list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);

        state = state.set('needReload', false);
        state = state.set('filter', fromJS(filter));
        let curPage = 1;
        let curArray = [];
        let curData = {};
        if (list.length > 0) {
          if (refresh) {
            state = state.set('totalPages', totalPages).set('totalDeclare', totalCount);
            curArray = normalizer.targetArrayNormalize(list);
            curData = normalizer.targetNormalize(list);
          } else {
            curPage = state.get('page') + 1;
            curArray = state
              .get('declareOrdering')
              .toJS()
              .concat(normalizer.targetArrayNormalize(list));
            curData = Object.assign(state.get('declareDataByTargetNo').toJS(), normalizer.targetNormalize(list));
          }
        } else {
          state = state.set('totalPages', 0).set('totalDeclare', 0);
        }
        return state
          .set('page', curPage)
          .set('declareOrdering', fromJS(curArray))
          .set('declareDataByTargetNo', fromJS(curData));
      },
      onFailure: (state, action) => {
        return state
          .set('declareOrdering', initialState.get('declareOrdering'))
          .set('declareDataByTargetNo', initialState.get('declareDataByTargetNo'));
      }
    }),

    // 신고 메일 탭 항목 조회
    ...pender({
      type: GET_DECLARE_MAIL,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }
        const { list, filter } = action.payload.data;
        const { refresh, offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = list.length > 0 ? list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);

        state = state.set('needReload', false);
        state = state.set('filter', fromJS(filter));
        let curPage = 1;
        let curArray = [];
        let curData = {};
        let detailArray = [];
        let detailData = {};
        if (list.length > 0) {
          if (refresh) {
            state = state.set('totalPages', totalPages).set('totalDeclare', totalCount);
            curArray = normalizer.declareArrayNormalize(list);
            curData = normalizer.declareNormalize(list);

            detailArray = fromJS(normalizer.examListArrayNormalize(list, 'declareNo'));
            detailData = Map(normalizer.examListNormalize(list, 'declareNo'));
          } else {
            curPage = state.get('page') + 1;
            curArray = state
              .get('declareOrdering')
              .toJS()
              .concat(normalizer.declareArrayNormalize(list));
            curData = Object.assign(state.get('declareDataByTargetNo').toJS(), normalizer.declareNormalize(list));

            // 메일탭 상세 정보 부분
            detailArray = fromJS(state.get('declareDetailOrdering').toJS().concat(normalizer.examListArrayNormalize(list, 'declareNo')));
            detailData = Map(Object.assign(state.get('declareDetail').toJS(), normalizer.examListNormalize(list, 'declareNo')));
          }
        } else {
          state = state.set('totalPages', 0).set('totalDeclare', 0);
        }

        return state
          .set('page', curPage)
          .set('declareOrdering', fromJS(curArray))
          .set('declareDataByTargetNo', fromJS(curData))
          .set('declareDetailOrdering', detailArray)
          .set('declareDetail', detailData);
      },
      onFailure: (state, action) => {
        return state
          .set('declareOrdering', initialState.get('declareOrdering'))
          .set('declareDataByTargetNo', initialState.get('declareDataByTargetNo'))
          .set('declareDetailOrdering', initialState.get('declareDetailOrdering'))
          .set('declareDetail', initialState.get('declareDetail'));
      }
    }),

    // 훈련 목록 조회
    ...pender({
      type: GET_DECLARE_EXAM,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { list } = action.payload.data;

        return state
          .set('declareExamOrdering', fromJS(normalizer.examArrayNormalize(list)))
          .set('declareExamByExamNo', fromJS(normalizer.examNormalize(list)));
      },
      onFailure: (state, action) => {
        return state.set('declareOrdering', initialState.get('declareOrdering')).set('declareExamByExamNo', Map({}));
      }
    }),

    // 신고 훈련 탭 항목 상세 조회
    ...pender({
      type: GET_DECLARE_DETAIL,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }
        const { list, filter } = action.payload.data;

        state = state.set('filter', fromJS(filter));

        return state
          .setIn(['declareDetailOrdering'], fromJS(normalizer.examListArrayNormalize(list, 'declareNo')))
          .setIn(['declareDetail'], Map(normalizer.examListNormalize(list, 'declareNo')));
      },
      onFailure: (state, action) => {
        return state.setIn(['declareDetail'], initialState.getIn(['declareDetail']));
      }
    }),

    // 신고 항목 수정
    ...pender({
      type: PUT_DECLARE,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const params = JSON.parse(action.payload.config.data);

        return state.setIn(['declareDetail', String(list.declareNo)], list);
      },
      onFailure: (state, action) => {
        //
      }
    }),
    // 신고 항목 삭제
    ...pender({
      type: DELETE_DECLARE,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { targetNo } = action.payload.config.params;

        return state
          .deleteIn(['declareDetail', String(list[0].declareNo)])
          .setIn(
            ['declareDataByTargetNo', String(targetNo), 'declareCount'],
            state.getIn(['declareDataByTargetNo', String(targetNo), 'declareCount']) - 1
          );
      },
      onFailure: (state, action) => {
        //
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/declare.js